import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AdminService } from 'app/admin/admin.service';
import { ManageRoles } from 'app/models/manageroles';
import { AuthorizedActions, UserAuthorizationRoleReq } from 'app/models/use-auth-role-req';
import { ReportsService } from 'app/services';
import { EnvironmentsService } from 'app/services/enviornment.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-authorization',
  templateUrl: './authorization.component.html',
  styleUrls: ['./authorization.component.scss']
})
export class AuthorizationComponent implements OnInit, OnDestroy {

  private products: Array<any> = null;
  private loaderAlertType: string = "alert-info";
  private vmwareProductsError: string = "";
  private readonly SUPER_ADMIN_AUTH_ROLE_ID: string = "1";
  private assignRoleForm: FormGroup = new FormGroup({
    "emailId": new FormControl('', Validators.required),
    "userName": new FormControl('', Validators.required),
    "product": new FormControl('', Validators.required),
    "role" : new FormControl('', Validators.required)
  })
  private manageRoleForm: FormGroup = new FormGroup({
    "product": new FormControl('', Validators.required),
    "authorizationType": new FormControl('', Validators.required),
    "authorizationRoleName": new FormControl('', Validators.required),
    "description" : new FormControl('', Validators.required)
  })
  private userList: Array<any> = [];
  private subs: Array<Subscription> = [];
  private roles: Array<any> = [];
  private showAlert: boolean = false;
  selectedProduct:number;
  roleName:string;
  private authUsersHeaders: Array<any> = [
    {
      label:"User",
      field: "userEmail"
    },
    {
      label: "Role",
      field: "authRole"
    },
    {
      label: "Updated by",
      field: "updatedBy"
    },
    {
      label: "Last update date",
      field: ""
    }//,
    //{
    //  label: "Actions",
    //  field: ""
    //}


  ]
  private users: Array<any> = [];
  private showEdit: boolean = false;
  private showRoleEdit: boolean = false;
  constructor(private reportService: ReportsService, private adminService: AdminService, private envService: EnvironmentsService,
    private translateService: TranslateService) { }


  ngOnInit() {
    this.getVMwareProducts();
    this.fetchUsers();
  }
  fetchUsers(){
    let sub = this.adminService.getAuthorizedUsers().subscribe(
      users =>{
        this.users = users;
      }
    )
    this.subs.push(sub);
  }
  getVMwareProducts(): void {
    let sub = this.reportService.getReleases(this.reportService.roleIds)
      .subscribe(
        vmwareProducts => {
          this.products = vmwareProducts;
          if (!this.products || this.products.length === 0) {
            this.showAlertMessage("Omnissa product list is not available.","alert-danger");
          }
        },
        err => {
          console.log(err);
          this.showAlertMessage("Unable to fetch Omnissa product list.", "alert-danger");
        });
    this.subs.push(sub);
  }
  getSuggestData(event: any) { // without type info
    if (event.target.value === '') {
      return;
    } else if (event.target.value.length < 3) {
      return;
    } else {
      this.reportService.getSuggestData(event.target.value)
        .subscribe(suggestData => {
          this.userList = suggestData;
        },
          err => {
            console.log(err);
          });
    }
  }
  updateFullName(event: any) {
    this.assignRoleForm.get('userName').setValue(
      this.userList.filter((ele) => { return ele.mail == event.target.value })[0].fullName);
  }
  fetchRoles(){
    try{
    let sub = this.adminService.getRolesForProduct(this.assignRoleForm.get('product').value).subscribe(
      (data)=>{
        this.roles = data.filter((role)=>{return role.authRole.id != this.SUPER_ADMIN_AUTH_ROLE_ID})
      }
    );
    this.subs.push(sub);
    }
    catch(e){
      window.alert("Session Timeout.")
    }
  }
  onSubmit(){
    let req= new UserAuthorizationRoleReq();
    let authRoleStr: string =this.assignRoleForm.get("role").value;
    req.authRoleId = parseInt(authRoleStr.split(":")[0]);
    req.authRoleDescription = authRoleStr.split(":")[1];
    req.userEmail = this.assignRoleForm.get("emailId").value;
    req.userName = this.assignRoleForm.get("userName").value;
    this.adminService.addUserAuthorizationRole(req, AuthorizedActions.ADD).subscribe(
      (response)=>{
        this.showAlertMessage("Successfully assigned role to the user!","alert-success");
        this.assignRoleForm.reset();
        this.fetchUsers();
      },
      (error)=>{
        if(error){
          if(error._body){
            try{
              let messageJson  = JSON.parse(error._body);
              if(messageJson){
                this.showAlertMessage(messageJson.message,"alert-danger");
              }
            }
            catch{
              this.showAlertMessage(error._body,"alert-danger");
            }
          }
          else
            this.showAlertMessage(error,"alert-danger");
        }
      }
    )
  }
  showAlertMessage(message: string, alertType: string){
    this.vmwareProductsError = message;
    this.loaderAlertType = alertType;
    this.showAlert = true;
    setTimeout(() => {
      this.showAlert = false;
    }, 10000);
  }
  manageUsers(user: any, action: string){
    //TODO
  }
  ngOnDestroy(): void {
    for (let index = 0; index < this.subs.length; index++) {
      const element = this.subs[index];
      element.unsubscribe();
    }
  }
  onProductSelect(){
    let product;
    let productIdsStr: string= this.manageRoleForm.get('product').value
    let productVal = parseInt(productIdsStr)
    for (let index = 0; index < this.products.length; index++) {
      if(this.products[index].id == productVal)
      product = this.products[index].rmVmwProduct;
    }
    this.manageRoleForm.get('authorizationRoleName').setValue(product + "_Admin")
  }
  onSubmitRole() {
    let createRoleReq = new ManageRoles();
    let productIdStr: string= this.manageRoleForm.get("product").value;
    createRoleReq.productId = parseInt(productIdStr.split(":")[0]);
    createRoleReq.authorizationType = this.manageRoleForm.get("authorizationType").value;
    createRoleReq.authRole = this.manageRoleForm.get("authorizationRoleName").value;
    createRoleReq.authCode = "PRGM_MGMT";
    createRoleReq.rolesDescription = this.manageRoleForm.get("description").value;
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    createRoleReq.updatedBy = currentUser.email;
    let sub = this.adminService.manageRoles(createRoleReq).subscribe(
      (response)=>{
        this.showAlertMessage("Successfully added the role","alert-success");
        this.manageRoleForm.reset();
      }
    )
    this.subs.push(sub)
  }
}



// WEBPACK FOOTER //
// ./src/app/authorization/authorization.component.ts